import React from 'react'
import Link from 'next/link'
import { Box, Container, Grid, Typography } from '@mui/material/'
import NewsTabs from '@containers/Home/NewsTabs'
import { sortKanaDesc } from '@libs/sortKanaDesc'
import { WordCategoryFragment } from '@services/graphcms/client'

type Props = {
  wordCategories: WordCategoryFragment[]
}

export const Words = (props: Props) => (
  <>
    <NewsTabs />
    <Container maxWidth="md">
      <Box marginTop={2} marginBottom={8} minHeight="78vh">
        <Typography align="center" fontWeight="bold" variant="h5">
          用語集
        </Typography>
        <Box marginTop={3}>
          {Array.isArray(props.wordCategories) &&
            props.wordCategories.sort(sortKanaDesc('nameKana')).map((wordCategory) => (
              <>
                <Box marginTop={6} marginBottom={2}>
                  <Typography fontWeight="bold" variant="h6">
                    {wordCategory.name}
                  </Typography>
                </Box>
                <Grid container={true} spacing={4}>
                  {Array.isArray(wordCategory.words) &&
                    wordCategory.words.sort(sortKanaDesc('titleKana')).map((word) => (
                      <Grid key={word.id} item={true}>
                        <Link href={`/word/${word.id}`}>
                          <a>
                            <Typography>{word.title}</Typography>
                          </a>
                        </Link>
                      </Grid>
                    ))}
                </Grid>
              </>
            ))}
        </Box>
      </Box>
    </Container>
  </>
)
